/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { HttpClient } from '@angular/common/http';
import { HotelBookingCancellation } from '@app/hotels/hotel-booking-cancellations/hotel-booking-cancellation.model';
import { Model } from '@app/shared/models/model.model';

@Injectable({
  providedIn: 'root',
})
export class HotelBookingCancellationsService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/hotel_booking_cancellations', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((hotelBookingCancellation: HotelBookingCancellation) => {
          return new HotelBookingCancellation().deserialize(hotelBookingCancellation);
        });
        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(hotelBookingCancellation: HotelBookingCancellation): Observable<HotelBookingCancellation> {
    return this.http
      .put('v1/hotel_booking_cancellations/' + hotelBookingCancellation.id, hotelBookingCancellation)
      .pipe(
        map((response: HttpResponse) => {
          return new HotelBookingCancellation().deserialize(response.data);
        })
      );
  }

  store(hotelBookingCancellation: HotelBookingCancellation): Observable<HotelBookingCancellation> {
    return this.http.post('v1/hotel_booking_cancellations', hotelBookingCancellation).pipe(
      map((response: HttpResponse) => {
        return new HotelBookingCancellation().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/hotel_booking_cancellations/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new HotelBookingCancellation().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/hotel_booking_cancellations/' + id);
  }
}
